import api from "@/apis/JobTitleAPI";
import Crud from "./crud-base";
var crud = new Crud("JobTitle", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "JobTitleID",
      code: "JobTitleCode",
      name: "JobTitleName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
